import { createApp, nextTick } from 'vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';

const header_part = createApp({
    methods: {
        showInfo() {
            Swal.fire({
                icon: 'info',
                title: (<HTMLInputElement>document.getElementById('book_name')).value,
                text: (<HTMLInputElement>document.getElementById('book_description')).value,
            });
        },
    },
});
header_part.mount('#header_part');
